import React from "react";
import "./Disclaimer.css";
import { strings } from "../../translations/strings";
import ExclamationIcon from "../../assets/icons/Exclamation.svg";

const Disclaimer = ({ colors }) => {
  return (
    <div className="disclaimer-container">
      <img
        className="exclamation-icon"
        alt="Exclamation"
        src={ExclamationIcon}
        draggable={false}
      />
      <span className="disclaimer-text" style={{ color: colors.tabText }}>
        {strings.no_data_will_be_saved}
      </span>
    </div>
  );
};
export default Disclaimer;
